/**
 * Способ получения услуги
 */
export const EWayToGet = {
    OFFICE: 'office',
    DELIVERY: 'delivery',
};

export const EValidationStatus = {
    INVALID: 'invalid',
    IDDLE: 'iddle',
    VALID: 'valid',
};

/**
 * Коды доставки для бэка
 */
export const EAppointmentDeliveryType = {
    MB: 'mb',
    OFFICE: 'office',
    COURIER: 'courier',
};

/**
 * Идентификатор продукта
 * @see https://wiki.domrf.ru/pages/viewpage.action?pageId=286621954
 */
export const EMBProductCode = {
    DEPOSITS: 'deposits',
    ESCROW: 'escrow',
    ACCOUNT: 'current_account',
    AKKREDITIV: 'akkreditiv',
    DEBIT_CARD: 'debit_cards',
    SALARY_CARD: 'issuance_of_salary_cards',
    PREMIUM: 'premium_package',
    LOANS: 'cash_loan',
    STICKER: 'payment_sticker',
};
